
import scenes from "@/config/scenes";

function getScene (rootState) {
    const route = rootState.context.route;
    if ( route && route.params.sid ) {
        return scenes[route.params.sid];
    } else {
        return scenes.fallback;
    }
}

export default {

    namespaced: true,

    state: {
        info: -1,
        person: -1,
    },

    getters: {
        sessionInfo (state, getters, rootState) {
            const scene = getScene(rootState);
            return scene.session.info;
        },
        sessionPerson (state, getters, rootState) {
            const scene = getScene(rootState);
            return scene.session.person;
        } ,
    },

    actions: {

        setSession ({commit}, data) {
            commit('session', data);
        },

        setPerson ({commit}, data) {
            commit('person', data);
        },

    },

    mutations: {
        session (state, data) {
            state.info = data;
        },

        person (state, data) {
            state.person = data;
        }
    }
}